import script from "./SearchAuthorInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchAuthorInput.vue?vue&type=script&setup=true&lang=js"

import "./SearchAuthorInput.vue?vue&type=style&index=0&id=918a7428&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-918a7428"]])

export default __exports__